import { Link } from 'react-router-dom';

type EmptyStateProps = {
  icon?: string;
  title: string;
  description: string;
  primaryAction?: { label: string; onClick?: () => void; to?: string };
  secondaryAction?: { label: string; onClick?: () => void; to?: string };
};

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  primaryAction,
  secondaryAction,
}: EmptyStateProps) {
  const renderAction = (
    action: { label: string; onClick?: () => void; to?: string },
    variant: 'primary' | 'ghost',
  ) => {
    const className =
      variant === 'primary'
        ? 'inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-600'
        : 'inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-[13px] text-foreground-700 transition-colors hover:border-primary-500/60 hover:text-primary-400';

    if (action.to) {
      return (
        <Link key={action.label} to={action.to} className={className}>
          {action.label}
        </Link>
      );
    }
    return (
      <button key={action.label} type="button" onClick={action.onClick} className={className}>
        {action.label}
      </button>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-background-300 bg-background-200 text-foreground-400">
        <i className={`${icon} text-2xl`} />
      </span>
      <h3 className="text-base font-medium text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-[13px] leading-6 text-foreground-500">{description}</p>
      {(primaryAction || secondaryAction) && (
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2.5">
          {primaryAction && renderAction(primaryAction, 'primary')}
          {secondaryAction && renderAction(secondaryAction, 'ghost')}
        </div>
      )}
    </div>
  );
}